const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export async function login(login, senha) {
  const res = await fetch(`${API_BASE}/users/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ login, senha })
  });
  if (!res.ok) throw new Error('login failed');
  return res.json();
}

// VAGAS -----------------------------------------------------------------------------------

export async function fetchVagas() {
  const resp = await fetch(`${API_BASE}/vagas`);
  if (!resp.ok) 
    throw new Error("bad response");
  
  return await resp.json();
}

export async function fetchActiveVagas() {
  const resp = await fetch(`${API_BASE}/vagas/activevagas`);
  if (!resp.ok) 
    throw new Error("bad response");

  return await resp.json();
}

export async function fetchVaga(code) {
  const res = await fetch(`${API_BASE}/vagas/${code}`);
  if (!res.ok) 
    throw new Error('bad response');

  return await res.json();
}

